const initialState = {
    arr: []
}

const crewAgenciesReducer = (state = initialState, action) => {
    switch(action.type){
        case 'CREW_AGENCIES' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default crewAgenciesReducer